module.exports = __webpack_public_path__ + "img/logo.bb4ae799.png";